import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { navigateToUrl } from 'utils/general';

import {
  useGetPaymentMethod,
  useUpdatePaymentMethod,
} from '@/modules/payment/apiHooks';
import { Typography } from '@/shared/components/atoms';

import Envelope from '~/images/shared/Envelope.svg';

const CardDetailsCard = () => {
  const { t } = useTranslation('payment');
  const { data } = useGetPaymentMethod();
  const {
    mutate: updatePaymentMethod,
    isSuccess,
    data: updatedData,
  } = useUpdatePaymentMethod();

  const handleEditPaymentMethod = () => {
    updatePaymentMethod();
  };

  useEffect(() => {
    if (isSuccess && updatedData) {
      navigateToUrl(updatedData.url);
    }
  }, [isSuccess, updatedData]);

  return (
    <div className='flex h-full w-full flex-col gap-20 rounded-xl border-xs border-neutralVariant-90 bg-background-neutral-99 p-24 '>
      {data ? (
        <>
          <div className='flex flex-col gap-2'>
            <div className='flex justify-between gap-2'>
              <div className='flex flex-col'>
                <Typography
                  variant='body1'
                  weight='semiBold'
                  className='text-text-default'
                >
                  {t('payment-method')}
                </Typography>
                <Typography variant='body2' className='text-surface-10'>
                  {t('change-pay-plan')}
                </Typography>
              </div>
            </div>
          </div>
          <div className='flex gap-16 rounded-xl border-xs border-neutralVariant-80 p-16'>
            <div className='h-fit rounded-lg border-xs border-outline-default px-16 py-2'>
              {data.brand}
            </div>
            <div className='flex flex-col gap-0'>
              <Typography variant='body2' weight='medium'>
                {t('visa-ending-in')} {data.last4}
                {/* TODO: add error here */}
              </Typography>

              <Typography
                variant='caption'
                weight='medium'
                className='h-fit text-surface-10'
              >
                {t('expiry')} {data.expMonth}/{data.expYear}
              </Typography>
              <Typography
                variant='caption'
                weight='medium'
                className='mt-2 flex items-center gap-2 text-surface-10'
              >
                <span className='text-primary-default'>
                  <Envelope />
                </span>
                <span>{data.billingEmail}</span>
              </Typography>
            </div>
            <div
              onClick={handleEditPaymentMethod}
              className='ml-auto mr-0 h-fit cursor-pointer rounded-lg border-xs border-outline-default px-16 py-2 text-base font-medium text-primary-default rtl:ml-0 rtl:mr-auto'
            >
              {t('edit')}
            </div>
          </div>
        </>
      ) : (
        <div className='flex h-full w-full items-center justify-center'>
          {t('no-payment-plan')}
        </div>
      )}
    </div>
  );
};

export { CardDetailsCard };
